module.exports = __webpack_public_path__ + "img/IMG_8_Secondary_Healing_D3.e4394f16.jpg";